/**
 * URL-serializes nested plain objects for router query strings.
 */
function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function JSON_to_URLEncoded(element: unknown, key?: unknown, args?: string[]) {
  const list: string[] = args || [];
  if (isRecord(element)) {
    for (const idx in element) {
      JSON_to_URLEncoded(element[idx], key ? String(key) + "[" + idx + "]" : idx, list);
    }
  } else {
    list.push(String(key) + "=" + encodeURIComponent(String(element)));
  }
  return list.join("&");
}
